import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProductService } from '../../../../../../../../../../SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/product/services/product.service';
import { SubscriptionService } from '../../../../../../../../../../SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/subscription/services/subscription.service';
import { FiltersChannel } from '../../../../filters/models/filters-channel.model';
import { IGridSettings } from '../../../../smart-grid/interfaces/grid-settings.interfaces';
import { IDashboard } from '../../../interfaces/dashboard.interface';
import { IDashboardSettings } from '../../../interfaces/dashboard-settings.interface';
import { Dashboard } from '../../../models/dashboard.model';
import { DashboardService } from '../../../services/dashboards.service';
import { DashboardSettingsService } from '../../../services/dashboards-settings.service';
import { FilterDemoTourService } from '../../../services/filter-demo-tour.service';
import { DeleteOptionChoiceDialogComponent } from '../../dialogs/delete-option-choice/delete-option-choice.component';

@Component({
  standalone: false,
  selector: 'suvo-bi-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy, OnChanges {
  private readonly dashboardSettingsService = inject(DashboardSettingsService);

  @Input() settings: IDashboardSettings;
  @Input() dashboard: Dashboard;
  @Input() filtersChannel: FiltersChannel;
  @Input() isCreation = false;
  @Input() isEditable = false;
  displayNameLabel = 'Page title';

  @Output() dashboardChanged = new EventEmitter<boolean>();
  // @Output() saveDashboard = new EventEmitter();
  // @Output() dashboardChanged = new EventEmitter();
  // @Output() deleteDashboard = new EventEmitter();
  // @Output() toggleFiltersDrawer = new EventEmitter();

  hasRestrictions = false;
  @Input() editMode: boolean = false;
  currentDashboard: Dashboard;
  isTrialing = false;
  filtersType: string;
  gridSettings: IGridSettings;

  private readonly unsubscribe$ = new Subject<void>();

  constructor(
    private readonly dashboardService: DashboardService,
    private readonly filterDemoTourService: FilterDemoTourService,
    private readonly subscriptionService: SubscriptionService,
    private readonly matDialog: MatDialog,
    private readonly router: Router,
    private productService: ProductService,
  ) {
    this.gridSettings = {
      maxColumnCount: 3,
      canEdit: this.dashboardSettingsService.canEditDashboards,
      canEditJson: this.dashboardSettingsService.canEditDashboards,
    };
  }

  ngOnInit() {
    this.subscriptionService.currentSubscription
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((currentSubscription) => {
        if (currentSubscription && currentSubscription?.status === 'trialing') {
          this.isTrialing = true;
        }

        if (this.isEditable) {
          this.hasRestrictions = false;
        } else if (this.filtersChannel) {
          //TODO : Replace this Hack, Make this more appropriate for full dashboards, composed of potentially many features?
          this.hasRestrictions = this.productService.hasRestrictions('AGGREGATION', [
            'DATASOURCE:' + this.filtersChannel.channelName,
          ]);
        }
      });
  }

  ngOnChanges() {
    if (this.dashboard && !this.dashboard._id) {
      this.updateEditMode(true);
    }

    if (this.settings.filterGroup) {
      this.filtersType = this.settings?.filterLayout?.type || 'sidenav';
      // this.filtersSidenavService.setActive(this.filtersType === 'sidenav');
    }

    this.currentDashboard = this.dashboard;
    // this.onRowCountChanged();
  }

  ngOnDestroy() {
    // if (this.unsavedChanges) {
    //   this.discardChanges();
    // }
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onTileChange(tileDefinition, column) {
    column.tileDefinition = tileDefinition;
  }

  /*  EDIT MODE
   */

  updateEditMode(enabled?: boolean) {
    if (enabled != undefined) {
      this.editMode = enabled;
    } else if (this.editMode) {
      this.editMode = false;
    } else {
      this.editMode = true;
    }
  }

  // createJsonDialog(title: string, inputJson: string) {
  //   this.activeDialog?.close();

  //   const jsonDialog = this.dialog.open(TileJsonDialogComponent, {
  //     width: '768px',
  //     height: '768px',
  //     data: { title, json: inputJson },
  //   })

  //   this.activeDialog = jsonDialog;

  //   return jsonDialog;
  // }

  // editColumnJson(rowIndex: number, columnIndex: number) {

  //   const column = this.currentDashboard.rows[rowIndex].columns[columnIndex];
  //   const inputJson = JSON.stringify(column.tileDefinition, null, 4);
  //   const jsonDialog = this.createJsonDialog('Edit Tile Json', inputJson);

  //   jsonDialog.afterClosed().pipe(take(1), takeUntil(this.unsubscribe$)).subscribe(result => {
  //     if (result) {
  //       column.tileDefinition = new TileDefinition(JSON.parse(result));
  //       this.onChanged();
  //     }
  //   })
  // }

  // editDashboardJson() {

  //   var { rows, ...restOfDashboard } = this.currentDashboard;
  //   const inputJson = JSON.stringify(restOfDashboard, null, 4);
  //   const jsonDialog = this.createJsonDialog('Edit Dashboard Properties Json', inputJson);

  //   jsonDialog.afterClosed().pipe(take(1), takeUntil(this.unsubscribe$)).subscribe(result => {
  //     if (result) {
  //       let newDashboard = JSON.parse(result) as any;
  //       newDashboard.rows = rows;
  //       this.currentDashboard = new Dashboard(newDashboard);
  //       this.onChanged();
  //     }
  //   })

  // }

  /*  DRAG AND DROP
   */

  /*  SAVING AND CHANGES
   */

  saveChangesAsync = async (dashboard: IDashboard, publish: boolean) => {
    if (this.settings.canEdit) {
      await this.dashboardService.saveDashboard(dashboard as Dashboard);

      if (publish) {
        await this.dashboardService.publishDraft(dashboard);
        dashboard.published = true;
      }
    }
  };

  createDashboard(dashboard: Dashboard) {
    this.dashboardService.createDashboard(dashboard).then(() => {
      this.router.navigate(['/', 'dashboards']);
    });
  }

  /*  DEMO TOUR
   */

  demoTour() {
    this.filterDemoTourService.forceTour();
  }

  onDeleteClick() {
    this.matDialog.open(DeleteOptionChoiceDialogComponent, {
      data: {
        dashboard: this.dashboard,
      },
    });
  }

  gridContentChanged(ev) {
    this.dashboardChanged.next(ev);
  }
}
